module.exports = __webpack_public_path__ + "static/media/track.95880115.png";